import AbstractService from '@/services/abstractService'

class CountriesService extends AbstractService {
  endpoint = 'countries'

  index() {
    return this.http.get(`${this.endpoint}`, { params: { dashboard: true } })
  }

  delete(data) {
    return this.http.delete(`${this.endpoint}/${data}`)
  }

  post(data) {
    return this.http.post(this.endpoint, data)
  }

  put(id, data) {
    return this.http.put(`${this.endpoint}/${id}`, data)
  }
}

const Service = new CountriesService()

export default Service
